// Single source of truth for all analytics event names and property types

export const AnalyticsEvents = {
  // Auth
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  SIGN_OUT: 'sign_out',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  PASSWORD_RESET_COMPLETED: 'password_reset_completed',
  INVITE_ACCEPTED: 'invite_accepted',

  // Orders
  ORDER_CREATED: 'order_created',
  FILE_UPLOADED: 'file_uploaded',
  OCR_COMPLETED: 'ocr_completed',
  TRANSLATION_STARTED: 'translation_started',
  ORDER_COMPLETED: 'order_completed',
  ORDER_DOWNLOADED: 'order_downloaded',

  // Payments
  CHECKOUT_STARTED: 'checkout_started',
  CREDIT_PURCHASED: 'credit_purchased',
  SUBSCRIPTION_CHANGED: 'subscription_changed',
  AUTO_RECHARGE_TOGGLED: 'auto_recharge_toggled',
  BILLING_PORTAL_OPENED: 'billing_portal_opened',

  // Team
  MEMBER_INVITED: 'member_invited',
  MEMBER_REMOVED: 'member_removed',
  ROLE_CHANGED: 'role_changed',

  // Settings
  PROFILE_UPDATED: 'profile_updated',
  TIMEZONE_CHANGED: 'timezone_changed',
  LANGUAGE_CHANGED: 'language_changed',
  PASSWORD_CHANGED: 'password_changed',

  // Errors
  API_ERROR: 'api_error',
  UPLOAD_ERROR: 'upload_error',
  PROCESSING_ERROR: 'processing_error',
  CLIENT_EXCEPTION: 'client_exception',
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

// Property types per event category

export interface AuthEventProperties {
  method?: 'email' | 'invite';
  is_company?: boolean;
  user_type?: string;
  reason?: string;
}

export interface OrderEventProperties {
  order_id?: string;
  file_type?: 'pdf' | 'image' | 'word';
  file_size_bytes?: number;
  page_count?: number;
  document_category?: string;
  source_language?: string;
  target_language?: string;
  credits_used?: number;
}

export interface PaymentEventProperties {
  package_id?: string;
  credits_amount?: number;
  price_usd?: number;
  plan_name?: string;
  auto_recharge_enabled?: boolean;
}

export interface TeamEventProperties {
  member_email?: string;
  role?: string;
  team_size?: number;
}

export interface ErrorEventProperties {
  error_message: string;
  error_code?: number;
  endpoint?: string;
  component?: string;
}
